import GitHub from '@material-ui/icons/GitHub';
import LeakAddIcon from '@mui/icons-material/LeakAdd';
import React from 'react'
import styled from 'styled-components';

function Menu({menuItem}) {
    return (
        <MenuStyled>
            {
                menuItem.map((item)=> {
                    return <div className="grid-item" key={item.id}>
                        <div className="portfolio-content">
                            <div className="portfolio-image">
                                <img src={item.image} alt="" />
                                <ul>
                                <li>
                                    <a href={item.link1}>
                                        <GitHub />
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" href={item.link2} rel="noreferrer">
                                    <LeakAddIcon />
                                    </a>
                                </li>
                            </ul>
                            </div>
                            <h6>{item.title}</h6>
                            <p>{item.text}</p>
                        </div>
                    </div>
                })
            }
        </MenuStyled>
    )
}

const MenuStyled = styled.div`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 2rem;
        @media only screen and (max-width: 920px){
            grid-template-columns: repeat(2, 1fr);
        }
        @media only screen and (max-width: 670px){
            grid-template-columns: repeat(1, 1fr);
        }
    .grid-item {
        .portfolio-content {
            display: block;
            position: relative;
            overflow: hidden;
            h6{
                margin-top: 10px;
                font-size: 1.2rem;
            }
            p{
                font-size: .8rem;
            }
            img {
                width: 100%;
                height: 30vh;
                object-fit: cover;
            }
            ul {
                /* display: none; */
                transform: translateY(-600px);
                transition: all .8s ease-in-out;
                position: absolute;
                left: 50%;
                top: 40%;
                opacity: 0;
                li{
                        background-color: var(--border-color);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 2rem;
                        border-radius: 50%;
                        width: 3rem;
                        height: 3rem;
                        margin: 0 1rem;
                        transition: all 0.8s ease-in-out;
                        &:hover{
                            background-color: var(--primary-color);
                        }
                        a{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            transition: all 0.4s ease-in-out;
                        }
                    }
            }

            .portfolio-image {
                &::before{
                content: "";
                    position: absolute;
                    left: 2%;
                    top: 4%;
                    height: 0;
                    width: 0;
                    transition: all 0.4s ease-in-out;
                }
            }
            .portfolio-image:hover {
                ul {
                    transform: translateY(0);
                    /* display: block; */
                    transform: translate(-50%, -50%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.4s ease-in-out;
                    opacity: 1;
                    li{
                        transition: all 0.4s ease-in-out;
                        &:hover{
                            background-color: var(--primary-color);
                        }
                        a{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            transition: all 0.4s ease-in-out;
                        }
                    }

                    li:hover {
                        svg {
                            color: var(--white-color);
                        }
                    }
                    svg {
                        font-size: 2rem;
                    }
                }
                  &::before{
                    height: calc(100% - 33%) ;
                    width: calc(100% - 4%);
                    background-color: white;
                    opacity: 0.5;
                    transform-origin: left;
                    transition: all 0.4s ease-in-out;
                }
            }
        }
    }
`;

export default Menu
